import React from 'react';
import { ucfirst } from '~/lib/Utils.js';
import StripeIcon from '~/components/icons/StripeIcon.jsx';
import SquareIcon from '~/components/icons/SquareIcon';

const PaymentStepSkeleton = ({paymentProcessor}) => {
    return (
        <div className="flex flex-col md:flex-row items-start md:items-stretch gap-4">
            <div className="w-full md:w-1/2 px-6 py-12 rounded-lg text-center border flex flex-col items-center justify-center">
                <div className="text-lg font-semibold">
                    {paymentProcessor === 'stripe' && <StripeIcon className="w-[100px]" />}
                    {paymentProcessor === 'square' && <SquareIcon className="w-[100px]" />}
                    {!['stripe', 'square'].includes(paymentProcessor) && (
                        <div>
                            {ucfirst(paymentProcessor || 'Payment Processor')}
                        </div>
                    )}
                </div>
                <div className="text-gray-500 text-md mt-2">
                    The checkout form from {ucfirst(paymentProcessor)} will display here
                </div>
            </div>
            <div className="w-full md:w-1/2 md:h-full px-6 py-12 rounded-lg text-center bg-gray-100 flex flex-col items-center justify-center">
                <div className="text-lg font-bold">Summary</div>
                <div className="text-md mt-2">
                    Line item summary will display here
                </div>
            </div>
        </div>
    );
}

export default PaymentStepSkeleton;
